import { totalRecordByProjectConstants } from '../constant/totalRecord.constants';
import { totalRecordByProject } from '../services/totalRecord.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getTotalRecordByProject = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        totalRecordByProject.list(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res.result));
                            if (res['error_code']) {
                                dispatch(failure(res['error_code']));
                            }
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;

                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(totalRecordByProjectList) { 
        return { type:  totalRecordByProjectConstants.GET_SUCCESS, totalRecordByProjectList }; 
    }

    function failure(error) { 
        return { type:  totalRecordByProjectConstants.GET_FAILURE, error }; 
    }
}
